import React, { useEffect, useRef, useState } from 'react';
import { Cell, FontIcon, Grid } from 'react-md';
import styled from 'styled-components';
import ForumIcon from '@material-ui/icons/Forum';
import ForumOutlinedIcon from '@material-ui/icons/ForumOutlined';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

import QuestionsAndAnswers from './questionsAndAnswers/QuestionsAndAnswers';
import Attendees from './attendees/Attendees';
import { EUREKA_TALK_HOST } from '../../../../../../../config';
import Auth from '../../../../../../../services/api/auth';

import { getQuestionSetByExternalObject } from '../../../services/QuestionsAndAnswersService';
import { getAttendeesByEventIdPaginated } from '../../../services/AttendeesService';

import { useVMState } from '../../../containers/main';
import Chat from '../../../../Talk/components/Chat';

import SettingsModal from './sessionSettings';

import Dropdown from '../../common/Dropdown';
// Uses tge global Talk manager for scenes/Talk
import TalkManager, { XMPPEvent } from '../../../../../../Talk/services';
import { LightTooltip } from '../common/styles';

const StyledGrid = styled(Grid)`
    color: rgba(0, 0, 0, 0.54) !important;
    margin: 0 0 8px 0 !important;
    background: #fff;
    flex-wrap: nowrap !important;
    border-bottom: 1px solid #edeef2;
    padding: 0 16px !important;
    height: 48px !important;
    align-items: center !important;
`;

const StyledCell = styled(Cell)`
    cursor: pointer;
    text-align: center;
    display: flex;
    justify-content: center;
    flex: 2;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    align-items: center;
    position: relative;
    margin: 4px 0 !important;
    height: 48px;
    padding: 16px 0 17px 0 !important;
    color: ${props => (props.active === 'true' ? '#1fa294' : 'inherit')};
    font-weight: ${props => (props.active === 'true' ? '500' : 'normal')};

    ${props =>
        props.active === 'true'
            ? `
        color: #1fa294 !important;
        font-weight: bold;
        border-bottom: solid 3px #1fa294;
        border-top: solid 3px #fff;
    `
            : ``}
    &:hover {
        ${props =>
            props.active === 'true'
                ? ` `
                : `
        background: ${'#1fa294' + '10'};
        color: #1fa294 !important;
        width: 100% !important;
        height: 40px;
        border-radius: 8px;`}
    }
`;

const Padding16px = styled.span`
    padding: 0 16px;
    height: 100%;
    min-height: 0;
`;

const IconStyledCell = styled(StyledCell)`
    max-width: 56px !important;

    &:hover {
        background: transparent;
    }
`;

const StyledChip = styled.span`
    text-align: center;
    justify-content: center;
    font-family: 'Cabin', sans-serif;
    font-size: 10px;
    color: #fff;
    display: flex;
    width: 16px;
    height: 16px;
    border-radius: 10px;
    align-items: center;
    position: absolute;
    bottom: 28px;
    transform: translateX(-5px);
    background-color: #1fa294;
`;

const UnreadMessagesCount = styled(StyledChip)`
    right: -8px;
    bottom: 18px;
    transform: unset;
    background-color: red;
`;

const StyledQANotificationsChip = styled.span`
    text-align: center;
    justify-content: center;
    font-family: 'Cabin', sans-serif;
    font-size: 10px;
    color: ${props => (props.secondaryColor ? '' : '#fff')};
    display: flex;
    width: 18px;
    height: 18px;
    border-radius: 10px;
    align-items: center;
    background-color: ${props => (props.secondaryColor ? '#f1f1f3' : '#1fa294')};
    transform: translate(-18px, -15px);
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

const SettingsIcon = styled(FontIcon)`
    cursor: pointer;
    border-radius: 50%;
    color: rgba(0, 0, 0, 0.54);
    padding: 12px;
    font-size: 24px !important;

    &:hover {
        color: rgba(0, 0, 0, 0.87);
        background: #f1f1f3;
    }
`;

const QAHeaderWrapper = styled.div`
    height: 48px;
    width: 100%;
    border-bottom: #e6e6e6 1px solid;
    margin-bottom: 8px;
    padding: 0 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
`;

const ChatHeaderWrapper = styled.div`
    height: 48px;
    width: 100%;
    border-bottom: #e6e6e6 1px solid;
    padding: 0 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const ChipWrapper = styled.button`
    height: 32px;
    width: ${props => (props.displayOnlyIcon ? 'fit-content' : '104px')};
    border-radius: 20px;
    background-color: ${props => (props.isActive ? '#1fa294' : '#f1f1f3')};
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px !important;
    font-family: Roboto, sans-serif !important;
    font-weight: 500 !important;
    line-height: 1.6 !important;
    color: ${props => (props.isActive ? '#fff' : 'rgba(0, 0, 0, 0.6)')};
    transform: ${props => (props.reAlignLeft ? 'translate(-18px, -4px);' : 'translateY(-4px);')};
    cursor: pointer;
    border: none;
`;

const ChipText = styled.span`
    margin-left: 8px;
`;

const LeftSideContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
`;

const RightSideContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
`;

const ChatType = Object.freeze({
    Attendees: 'attendees',
    Speakers: 'speakers',
});

const Tab = Object.freeze({
    Chat: 'chat',
    QA: 'qa',
    Attendees: 'attendees',
});

const ATTENDEES_LIMIT = 12;
export const SORT_QUESTIONS_BY = {
    NEWEST_FIRST: 'Newest first',
    MOST_POPULAR: 'Most popular first',
};

const Chip = ({ icon, iconClassName }) => (
    <FontIcon
        iconClassName={iconClassName}
        style={{
            fontSize: '24px',
            color: 'inherit',
            marginRight: '6px',
        }}
    >
        {icon}
    </FontIcon>
);

const VisibilityChip = ({ visible, isActive, onClick, moveLeft, displayOnlyIcon }) => {
    const iconStyle = { fontSize: 16 };
    if (displayOnlyIcon) {
        return (
            <LightTooltip title={visible ? 'Visible' : 'Invisible'}>
                <ChipWrapper
                    onClick={onClick}
                    isActive={isActive}
                    reAlignLeft={moveLeft}
                    displayOnlyIcon={displayOnlyIcon}
                >
                    {visible ? (
                        <VisibilityIcon style={iconStyle} />
                    ) : (
                        <VisibilityOffIcon style={iconStyle} />
                    )}
                </ChipWrapper>
            </LightTooltip>
        );
    }
    return (
        <ChipWrapper
            onClick={onClick}
            isActive={isActive}
            reAlignLeft={moveLeft}
            displayOnlyIcon={displayOnlyIcon}
        >
            {visible ? (
                <VisibilityIcon style={iconStyle} />
            ) : (
                <VisibilityOffIcon style={iconStyle} />
            )}
            <ChipText>{visible ? 'Visible' : 'Invisible'}</ChipText>
        </ChipWrapper>
    );
};

const UserInteraction = ({ controls, nonVirtualQA }) => {
    const [tab, setTab] = useState(Tab.Chat);
    const [questions, setQuestions] = useState([]);
    const [questionSetsId, setQuestionSetsId] = useState(null);
    const [newQuestionsCount, setNewQuestionsCount] = useState(0);
    const [attendees, setAttendees] = useState([]);
    const [attendeesCount, setAttendeesCount] = useState(0);
    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const [page, setPage] = useState(1);
    const [showBlockModal, setShowBlockModal] = useState(false);
    const [activeChat, setActiveChat] = useState(ChatType.Attendees);
    const [isFetching, setIsFetching] = useState(false);
    const [columnWidth, setColumnWidth] = useState(false);
    const [showQuestions, setShowQuestions] = useState({
        visible: true,
        invisible: false,
    });
    const [orderBy, setOrderBy] = useState(SORT_QUESTIONS_BY.MOST_POPULAR);
    const [chatRoomIds, setChatRoomIds] = useState({
        [ChatType.Attendees]: undefined,
        [ChatType.Speakers]: undefined,
    });
    const [unreadMessagesCount, setUnreadMessagesCount] = useState({
        [ChatType.Attendees]: 0,
        [ChatType.Speakers]: 0,
    });

    const newQuestionsCountRef = useRef(newQuestionsCount);
    const newQuestionsIdsRef = useRef([]);
    const newAddedQuestionsIdsRef = useRef([]);
    const tabRef = useRef(tab);
    const showQuestionsRef = useRef(showQuestions);
    const questionIds = useRef([]);

    const stateCtx = useVMState();
    const { sessionId, externalObject, socket, virtualEventSession } = stateCtx;
    const { showChat, showQA, showAttendees } =
        virtualEventSession && virtualEventSession.data ? virtualEventSession.data : {};
    const unreadAttendeesMessages = unreadMessagesCount[ChatType.Attendees];
    const unreadSpeakersMessages = unreadMessagesCount[ChatType.Speakers];
    const unreadChatMessagesCount = unreadAttendeesMessages + unreadSpeakersMessages;
    const userInteractionColumnElem = document.getElementById('user-interaction-column');

    const showAttendeesChat = controls || showChat;

    useEffect(() => {
        if (!chatRoomIds[ChatType.Attendees] || !chatRoomIds[ChatType.Speakers]) {
            return;
        }

        const handleGroupMessage = ({ conversation }) => {
            const chatType = Object.keys(chatRoomIds).find(
                key => chatRoomIds[key] === conversation.id,
            );
            if (tab === Tab.Chat && chatType === activeChat) {
                return;
            }

            setUnreadMessagesCount({
                ...unreadMessagesCount,
                [chatType]: unreadMessagesCount[chatType] + 1,
            });
        };

        TalkManager.subscribeToEvent(XMPPEvent.GroupMessage, handleGroupMessage);

        return () => {
            TalkManager.unsubscribeFromEvent(XMPPEvent.GroupMessage, handleGroupMessage);
        };
    }, [chatRoomIds, unreadMessagesCount, tab, activeChat]);

    useEffect(() => {
        if (tab === Tab.Chat) {
            setUnreadMessagesCount({
                [ChatType.Attendees]:
                    activeChat === ChatType.Attendees ? 0 : unreadMessagesCount[ChatType.Attendees],
                [ChatType.Speakers]:
                    activeChat === ChatType.Speakers ? 0 : unreadMessagesCount[ChatType.Speakers],
            });
        }
    }, [tab, activeChat]);

    useEffect(() => {
        let currentUser = Auth.getUser();

        return () => {
            TalkManager.leaveVMRooms({ userId: currentUser.id });
            //TalkManager.disconnect();
        };
    }, []);

    useEffect(() => {
        fetchQuestions();

        const handleQuestionUpdates = questionData => {
            const { question } = questionData;

            if (controls && questionData.action === 'addQuestion') {
                newAddedQuestionsIdsRef.current.push(question.id);
                setNewQuestionsCountExtra(newQuestionsCountRef.current + 1);
                if (showQuestionsRef.current.visible) {
                    if (!questionIds.current.find(item => item === question.id)) {
                        questionIds.current.push(question.id);
                    }
                }
            }

            if (
                controls &&
                questionData.action === 'updateQuestion' &&
                !questionData.updateWithoutCount
            ) {
                if (question.visible && showQuestions.visible) {
                    if (!questionIds.current.find(item => item === question.id)) {
                        questionIds.current.push(question.id);
                    }
                }

                if (!question.visible && showQuestions.visible) {
                    if (!questionIds.current.find(item => item === question.id)) {
                        questionIds.current.push(question.id);
                    }
                }
            }

            if (!controls && questionData.action === 'updateQuestion') {
                // if question is not visible => it becomes visible now
                if (
                    question.visible &&
                    !newQuestionsIdsRef.current.find(id => id === question.id)
                ) {
                    newQuestionsIdsRef.current.push(question.id);
                    setNewQuestionsCountExtra(newQuestionsCountRef.current + 1);
                }

                if (
                    !question.visible &&
                    newQuestionsIdsRef.current.find(id => id === question.id)
                ) {
                    newQuestionsIdsRef.current = newQuestionsIdsRef.current.filter(
                        id => id !== question.id,
                    );
                    setNewQuestionsCountExtra(newQuestionsCountRef.current - 1);
                }
            }

            fetchQuestions();
        };

        socket.on('updateQuestions', handleQuestionUpdates);

        if (!nonVirtualQA) {
            fetchAttendees();
            socket.on(`refreshAttendees_${sessionId}`, () => {
                setPage(1);
                fetchAttendees();
            });
        }

        return () => {
            if (socket && socket.removeAllListeners) {
                socket.removeAllListeners(`refreshAttendees_${sessionId}`);
                socket.removeAllListeners('updateQuestions', handleQuestionUpdates);
            }
        };
    }, []);

    useEffect(() => {
        if (controls) {
            return;
        }

        setTab(value => {
            const valueMap = {
                chat: true,
                qa: showQA,
                attendees: showAttendees,
            };

            // if the current value is available, keep it
            if (valueMap[value]) {
                return value;
            }

            // otherwise change it
            return Object.values(Tab).find(opt => {
                if (opt !== value && valueMap[opt]) {
                    return opt;
                }

                return false;
            });
        });
    }, [virtualEventSession]);

    useEffect(() => {
        if (!showAttendeesChat) {
            setActiveChat(ChatType.Speakers);
        }
    }, [showAttendeesChat]);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [userInteractionColumnElem]);

    const handleResize = () => {
        setColumnWidth(userInteractionColumnElem?.offsetWidth);
    };

    const setNewQuestionsCountExtra = count => {
        newQuestionsCountRef.current = count;
        setNewQuestionsCount(count);
        if (count === 0) {
            resetQuesttionIds();
        }
    };

    const resetQuesttionIds = () => {
        newAddedQuestionsIdsRef.current = [];
        newQuestionsIdsRef.current = [];
    };

    const fetchQuestions = async () => {
        const questionSets = await getQuestionSetByExternalObject(externalObject.data.id);
        let { Questions: questions } = questionSets;

        questions = questions.map(item => {
            item.newQuestion = !item.visible && newAddedQuestionsIdsRef.current.includes(item.id);
            item.newQuestionForSpeaker = newQuestionsIdsRef.current.includes(item.id);
            return item;
        });

        const invisibleQuestions = questions.filter(
            item =>
                !item.visible &&
                newAddedQuestionsIdsRef.current &&
                newAddedQuestionsIdsRef.current.includes(item.id),
        );
        newAddedQuestionsIdsRef.current = [];
        invisibleQuestions.forEach(q => newAddedQuestionsIdsRef.current.push(q.id));

        setQuestions(questions);
        setQuestionSetsId(questionSets.id);
    };

    const updateAttendeeList = (attendees, page) => {
        setAttendees(attendees);
        setIsFetching(false);
        setPage(page);
    };

    const fetchAttendees = async () => {
        const newAttendees = await getAttendeesByEventIdPaginated(sessionId, ATTENDEES_LIMIT, page);
        const attendeeList = attendees.concat(newAttendees.rows);
        const sortedRows = attendeeList.sort((attendee1, attendee2) => {
            const name1 = `${attendee1.lastName} ${attendee1.firstName}`;
            const name2 = `${attendee2.lastName} ${attendee2.firstName}`;
            return name1.toLowerCase().localeCompare(name2.toLowerCase());
        });
        setAttendees(sortedRows);
        setAttendeesCount(newAttendees.count);
        setPage(page);
        setIsFetching(false);
    };

    const handleShowQuestions = () => {
        questionIds.current = [];
        setShowQuestions(val => {
            const updatedShowQuestions = {
                visible: !val.visible,
                invisible: !val.invisible,
            };
            showQuestionsRef.current = updatedShowQuestions;
            return updatedShowQuestions;
        });
    };

    const renderQuestionAndAnswersHeader = () => {
        return (
            <QAHeaderWrapper>
                <LeftSideContainer>
                    <>
                        <VisibilityChip
                            visible={false}
                            isActive={showQuestions.invisible}
                            onClick={handleShowQuestions}
                            displayOnlyIcon={columnWidth <= 416}
                        />
                        {questionIds.current.length > 0 && showQuestions.visible && (
                            <StyledQANotificationsChip secondaryColor={showQuestions.invisible}>
                                {`+${questionIds.current.length}`}
                            </StyledQANotificationsChip>
                        )}
                    </>
                    <>
                        <VisibilityChip
                            visible={true}
                            isActive={showQuestions.visible}
                            onClick={handleShowQuestions}
                            displayOnlyIcon={columnWidth <= 416}
                            moveLeft={questionIds.current.length > 0 && showQuestions.visible}
                        />
                        {questionIds.current.length > 0 && showQuestions.invisible && (
                            <StyledQANotificationsChip secondaryColor={showQuestions.visible}>
                                {`+${questionIds.current.length}`}
                            </StyledQANotificationsChip>
                        )}
                    </>
                </LeftSideContainer>
                <RightSideContainer>
                    <Dropdown
                        buttonText={orderBy}
                        items={[
                            {
                                text: 'Newest first',
                                onClick: () => setOrderBy(SORT_QUESTIONS_BY.NEWEST_FIRST),
                                rightIcon:
                                    orderBy === SORT_QUESTIONS_BY.NEWEST_FIRST ? 'check' : null,
                            },
                            {
                                text: 'Most popular first',
                                onClick: () => setOrderBy(SORT_QUESTIONS_BY.MOST_POPULAR),
                                rightIcon:
                                    orderBy === SORT_QUESTIONS_BY.MOST_POPULAR ? 'check' : null,
                            },
                        ]}
                    />
                </RightSideContainer>
            </QAHeaderWrapper>
        );
    };

    const ChatTabs = () => (
        <ChatHeaderWrapper>
            {showAttendeesChat && (
                <LightTooltip title="Chat with attendees">
                    <ChipWrapper
                        isActive={activeChat === ChatType.Attendees}
                        onClick={() => {
                            setUnreadMessagesCount({
                                ...unreadMessagesCount,
                                [ChatType.Attendees]: 0,
                            });
                            setActiveChat(ChatType.Attendees);
                        }}
                    >
                        Attendees
                        {unreadAttendeesMessages > 0 && (
                            <UnreadMessagesCount>{unreadAttendeesMessages}</UnreadMessagesCount>
                        )}
                    </ChipWrapper>
                </LightTooltip>
            )}
            <LightTooltip title="Chat with speakers">
                <ChipWrapper
                    isActive={activeChat === ChatType.Speakers}
                    onClick={() => {
                        setUnreadMessagesCount({
                            ...unreadMessagesCount,
                            [ChatType.Speakers]: 0,
                        });
                        setActiveChat(ChatType.Speakers);
                    }}
                >
                    Speakers
                    {unreadSpeakersMessages > 0 && (
                        <UnreadMessagesCount>{unreadSpeakersMessages}</UnreadMessagesCount>
                    )}
                </ChipWrapper>
            </LightTooltip>
        </ChatHeaderWrapper>
    );

    const renderTab = () => {
        if (tab === Tab.Chat) {
            const sessionName = externalObject.data.title;
            return (
                <>
                    {!nonVirtualQA && <ChatTabs />}
                    {showAttendeesChat && (
                        <Chat
                            nonVirtualQA={nonVirtualQA}
                            itemId={sessionId}
                            itemName={sessionName}
                            moderatorOnly={false}
                            chatUrl={EUREKA_TALK_HOST}
                            isVisible={activeChat === ChatType.Attendees}
                            onChatRoomIdSet={chatRoomId =>
                                setChatRoomIds({
                                    ...chatRoomIds,
                                    [ChatType.Attendees]: chatRoomId,
                                })
                            }
                        />
                    )}
                    {!nonVirtualQA && (
                        <Chat
                            itemId={sessionId}
                            itemName={sessionName}
                            moderatorOnly
                            chatUrl={EUREKA_TALK_HOST}
                            isVisible={activeChat === ChatType.Speakers}
                            onChatRoomIdSet={chatRoomId =>
                                setChatRoomIds({
                                    ...chatRoomIds,
                                    [ChatType.Speakers]: chatRoomId,
                                })
                            }
                        />
                    )}
                </>
            );
        }

        if (tab === Tab.QA && shouldRenderQA()) {
            return (
                <>
                    {renderQuestionAndAnswersHeader()}
                    <QuestionsAndAnswers
                        orderBy={orderBy}
                        questions={questions}
                        showVisible={showQuestions.visible}
                        showInvisible={showQuestions.invisible}
                        fetchQuestions={fetchQuestions}
                        controls={true}
                        questionSetsId={questionSetsId}
                        nonVirtualQA={nonVirtualQA}
                    />
                </>
            );
        }

        if (tab === Tab.Attendees && shouldRenderAttendees()) {
            return (
                <Padding16px>
                    <Attendees
                        sortedAttendees={attendees}
                        controls={controls}
                        limit={ATTENDEES_LIMIT}
                        totalAttendees={attendeesCount}
                        setShowBlockModal={val => setShowBlockModal(val)}
                        showBlockModal={showBlockModal}
                        updateAttendeeList={updateAttendeeList}
                        externalIsFetching={isFetching}
                        externalPage={page}
                    />
                </Padding16px>
            );
        }

        return null;
    };

    const shouldRenderQA = () => controls || (!controls && showQA);

    const shouldRenderAttendees = () => (controls || (!controls && showAttendees)) && !nonVirtualQA;

    const changeTabAndResetQuestions = t => {
        setTab(t);
        tabRef.current = t;
        let oldQuestions = questions;
        oldQuestions = oldQuestions.map(item => {
            item.newQuestion = false;
            return item;
        });

        setQuestions(oldQuestions);
        setNewQuestionsCountExtra(0);
    };

    return (
        <Wrapper className="eureka-react" id={'user-interaction-column'}>
            <StyledGrid>
                <StyledCell
                    active={(tab === Tab.Chat).toString()}
                    onClick={() => {
                        changeTabAndResetQuestions(Tab.Chat);
                    }}
                >
                    <Chip icon={tab === Tab.Chat ? 'chat_bubble' : 'chat_bubble_outline'} />
                    Chat
                    {unreadChatMessagesCount > 0 && (
                        <StyledChip>{unreadChatMessagesCount}</StyledChip>
                    )}
                </StyledCell>
                {shouldRenderQA() && (
                    <StyledCell
                        active={(tab === Tab.QA).toString()}
                        onClick={() => {
                            setTab(Tab.QA);
                            tabRef.current = Tab.QA;
                        }}
                    >
                        <Chip icon={tab === Tab.QA ? <ForumIcon /> : <ForumOutlinedIcon />} />
                        Q&A
                        {newQuestionsCount > 0 && tab !== Tab.QA && (
                            <StyledChip>{newQuestionsCount}</StyledChip>
                        )}
                    </StyledCell>
                )}
                {shouldRenderAttendees() && (
                    <StyledCell
                        active={(tab === Tab.Attendees).toString()}
                        onClick={() => changeTabAndResetQuestions(Tab.Attendees)}
                    >
                        <Chip
                            iconClassName={
                                tab !== Tab.Attendees ? 'material-icons-outlined' : 'material-icons'
                            }
                            icon={'group'}
                        />
                        {`(${attendeesCount})`}
                    </StyledCell>
                )}
                {controls && (
                    <IconStyledCell active={'false'} onClick={() => setShowSettingsModal(true)}>
                        <SettingsIcon>settings</SettingsIcon>
                    </IconStyledCell>
                )}
            </StyledGrid>
            {renderTab()}
            {showSettingsModal && (
                <SettingsModal
                    onClose={() => setShowSettingsModal(false)}
                    questionSetsId={questionSetsId}
                    nonVirtualQA={nonVirtualQA}
                    externalObject={externalObject}
                />
            )}
        </Wrapper>
    );
};

export default UserInteraction;
